import AOS from 'aos';
import { tns } from "tiny-slider/src/tiny-slider";

AOS.init({
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  once: true
});

let imageSlider = document.querySelectorAll('.image-slider');
if(imageSlider.length){
  [].forEach.call(document.querySelectorAll('.image-slider'), function (el) {
    tns({
      container: el,
      autoHeight: true,
      controlsContainer: '.slider-controls',
      mode: 'gallery'
    });
  });

  [].forEach.call(document.querySelectorAll('.thumbnail-slider'), function (el) {
    tns({
      container: el,
      items: 1,
      controlsContainer: '.slider-controls',
      nav: false,
      responsive: {
        640: {
          edgePadding: 20,
          gutter: 20,
          items: 2
        },
        700: {
          gutter: 30
        },
        900: {
          items: 4
        }
      }
    });
  });
}

var dataVisSlider = document.querySelectorAll('.datavis-thumbnails');

dataVisSlider.forEach(function(el) {
  var sliderControls = el.nextElementSibling;
  tns({
    container: el,
    items: 2,
    controlsContainer: sliderControls,
    nav: false,
    gutter: 20,
    mouseDrag: true,
    loop: false,
    slideBy: 1,
    responsive: {
      640: {
        edgePadding: 20,
        gutter: 20,
        items: 2
      },
      700: {
        gutter: 30
      },
      900: {
        items: 3
      }
    }
  });
})


document.addEventListener('aos:in', ({ detail }) => {
  //console.log('animated in', detail);
});

document.addEventListener('aos:out', ({ detail }) => {
  //console.log('animated out', detail);
});


function getScrollbarWidth() {
  return window.innerWidth - document.body.scrollWidth;
}

var body = document.getElementsByTagName('body')[0];
var menuToggle = document.querySelector('.hamburger-menu');
var popoutNav = document.querySelector('#popout-nav');
var closeNav = document.querySelector('.close-nav');


menuToggle.addEventListener('click', function(){


	var scrollBarWidth = getScrollbarWidth();
	//console.log(scrollBarWidth, "scroll bar width");

	body.style.padding = "0 "+scrollBarWidth+"px 0 0";

	body.classList.toggle('nav-open');

});

closeNav.addEventListener('click', function(){

	body.classList.remove('nav-open');

	body.style.padding = "0";

});

var newsletterLink = document.querySelector('.newsletter-signup-open');
if(newsletterLink){
newsletterLink.addEventListener('click', function(){
    body.classList.toggle('nav-open');
});
}

var mainWidget = document.querySelector('.main-widget');
var mainWidgetTitle = document.querySelector('.main-widget-title');
var mainWidgetDescription = document.querySelector('.main-widget-description');
var clickableWidgets = document.querySelectorAll('.widget-embed');

clickableWidgets.forEach(item => {
  item.addEventListener('click', event => {
    //handle click
    let target = event.target;
    let targetIframe = target.dataset.iframe;
    let targetHeading = target.dataset.heading; 
    let targetDescription = target.dataset.description; 
    mainWidget.innerHTML = decodeURIComponent(targetIframe);
    mainWidgetTitle.innerHTML = targetHeading;
    mainWidgetDescription.innerHTML = decodeURIComponent(targetDescription);
    document.querySelectorAll('.active-item').forEach(function(el) {
      el.classList.remove('active-item');
    });
    target.parentNode.classList.add('active-item');
  });
})

var collapseMapBtn = document.querySelector('.collapse-map-btn');
var collapseMap = document.querySelector('.collapse-map');
if(collapseMapBtn && collapseMap){
collapseMapBtn.addEventListener('click', function(){
  collapseMap.classList.toggle('full');
  collapseMapBtn.classList.toggle('open');
});
};